<script setup>
import { onMounted } from 'vue'
import { RouterView } from 'vue-router'
import { useTheme } from './composables/useTheme.js'

const { initialiseTheme } = useTheme()
onMounted(initialiseTheme)
</script>

<template>
  <RouterView />
</template>
